import React, { useEffect, useState } from "react";
import ContentWrapper from "../views/components/ContentWrapper";
import { addBotInfo, approveBotInfo, deleteBotInfo, getBotInformation } from "../data/dataApi";
import Pagination from "../views/components/Pagination";
import { useParams, useNavigate } from "react-router";
import { Button, Form } from "react-bootstrap";
import EditBtn from "../images/edit.svg";
import DeleteBtn from "../images/delete.svg";
import ConfirmationModal from "../views/components/ConfirmationModal";
import EditModal from "../views/components/EditModal";
import { useUserState } from "../views/components/Mode";
import { formatDate } from "../views/helpers";

const InformTheBot = () => {
    const { page } = useParams();
    const { userRole, userId } = useUserState();

    const [informBot, setInformBot] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddButton, setShowAddButton] = useState(true);
    const [newMessage, setNewMessage] = useState("");
    const [showForm, setShowForm] = useState(false);
    const [newInfoError, setNewInfoError] = useState("");
    const [infoItem, setInfoItem] = useState();
    const [deleteInfoError, setDeleteInfoError] = useState("");
    const [loading, setLoading] = useState(false);
    const [approvingId, setApprovingId] = useState(null);

    const listLimit = 10;

    const handleDeleteClick = item => {
        setInfoItem(item);
        setShowDeleteModal(true);
    };

    const handleEditClick = item => {
        setInfoItem(item);
        setShowEditModal(true);
    };

    const deleteInformation = async () => {
        setDeleteInfoError("");
        const response = await deleteBotInfo(infoItem.id);

        if (response.success) {
            setInformBot(prevState => prevState.filter(info => info.id !== infoItem.id));
        } else {
            setDeleteInfoError(response.error.message);
        }

        return response.success;
    }

    const handleAddClick = () => {
        setShowAddButton(false);
        setShowForm(true);
    }

    const handleNewInfo = async () => {
        if (newMessage.trim() === "") {
            setNewInfoError("Please type new content or upload files.");
        } else {
            if (newMessage.trim() !== "") {
                setLoading(true);
                const response = await addBotInfo(newMessage);

                if (response.success) {
                    setLoading(false);
                    const { id, time, content, name, total_count, status } = response.data.rows[0];

                    setInformBot(prevState => {
                        const infoList = [...prevState];

                        infoList.unshift({
                            id,
                            date: time,
                            content,
                            author: name,
                            total_count,
                            status
                        });

                        return infoList;
                    });

                    setShowAddButton(true);
                    setShowForm(false);
                    setNewMessage('');
                    setShowAddModal(true);
                } else {
                    setNewInfoError(response.error.message);
                }
            }
        }
    };

    const handleApproveClick = async item => {
        setApprovingId(item.id);
        const response = await approveBotInfo(item.id, item.content);

        if(response.success) {
            setInformBot(prevState => {
                const infoList = [...prevState];
                const index = infoList.findIndex(info => info.id === item.id);

                infoList[index].status = "approved";

                return infoList;
            });
        }

        setApprovingId(null);
    };

    useEffect(() => {
        (async () => {
            const response = await getBotInformation(page - 1 || 0);

            const { data, success } = response;

            if (success) {
                setInformBot(data.rows.map(info => ({
                    id: info.id,
                    user_id: info.user_id,
                    date: info.time,
                    content: info.content,
                    author: info.name,
                    total_count: info.total_count,
                    status: info.status
                })));
            }
        })();
    }, [page]);

    return (
        <ContentWrapper className="inform-the-bot scrollable">
            <div className="wrapper">
                <div className="add-info-wrapper tif-mb-20">
                    {showAddButton ? <Button className="quinary-btn" onClick={handleAddClick}>+ <u>Add new information</u></Button> : null}
                </div>
                {showForm ?
                    <div className="add-user-form tif-mb-60">
                        <Form className="secondary-form">
                            <Form.Group className="form-group tif-mb-20" controlId="formNewContent">
                                <Form.Label className='tif-color-white'>Type new content here:</Form.Label>
                                <Form.Control className="multiline" placeholder="Type here" as="textarea" value={newMessage} onChange={(e) => setNewMessage(e.target.value )} />
                            </Form.Group>
                            {newInfoError && <p className="error-text tif-mb-5">{newInfoError}</p>}
                            <Button className='quarternary-btn' onClick={handleNewInfo} disabled={ loading }>{ loading ? "Saving..." : "Save" }</Button>
                        </Form>
                    </div>
                    : null}
                <ConfirmationModal
                    show={showAddModal}
                    changeVisibility={setShowAddModal}
                    type="success"
                    successMessage="You have successfully added new information."
                    close={
                        <Button className="tertiary-btn" onClick={() => setShowAddModal(false)}>
                            Back to Inform the Bot
                        </Button>
                    } />
                {informBot.map((item, index) => (
                    <div className="card tif-pt-15 tif-pb-30 tif-pl-30 tif-pr-85 tif-bg-color-bravo tif-bg-light-color-papa tif-mb-30 tif-color-white tif-light-color-november" key={index}>
                        <p className="tif-font-sm tif-mb-0">{formatDate(item.date)}</p>
                        <p className="tif-font-sm tif-mb-5">By {item.author}</p>
                        <div className="message">
                            {item.content}
                        </div>
                        {
                            (item.status === "pending") &&
                                <Button className="tif-mb-15" onClick={() => handleApproveClick(item)} disabled={(approvingId === item.id) || item.user_id === userId}>
                                    {
                                        item.user_id !== userId ?
                                            (approvingId === item.id) ?
                                                "Approving..."
                                            :
                                                "Approve"
                                        :
                                            "Pending approval"
                                    }
                                </Button>
                        }
                        <div className="edit-bot">
                            <Button className="edit-btn tif-mb-15" onClick={() => handleEditClick(item)}>
                                <img src={EditBtn} />
                            </Button>
                            {
                                userRole === "admin" &&
                                <Button className="edit-btn" onClick={() => handleDeleteClick(item)}>
                                    <img src={DeleteBtn} />
                                </Button>
                            }
                        </div>
                    </div>
                ))}
                <Pagination listLength={informBot.length && informBot[0].total_count} path="/inform-the-bot" page={page} limit={listLimit} />
            </div>
            <ConfirmationModal
                show={showDeleteModal}
                changeVisibility={setShowDeleteModal}
                type="delete"
                confirmationButton="Delete Information"
                confirmationMessage="Are you sure you want to delete this information?"
                successMessage="This information has been successfully deleted."
                modalFunction={deleteInformation}
                close={
                    <Button className="tertiary-btn" onClick={() => setShowDeleteModal(false)}>
                        Back to Inform the Bot
                    </Button>
                }
                error={deleteInfoError}
            />
            { infoItem && <EditModal infoItem={infoItem} show={showEditModal} changeVisibility={setShowEditModal} onUpdate={setInformBot} onChange={setInfoItem} /> }
        </ContentWrapper>
    );
};

export default InformTheBot;